import { ApiGarGarsListRequest, GAR } from "@nens/brostar/openapi-client";
import { ColumnDefinition } from "@nens/chakra/components";

import { getSearchKey } from "@/components/searchbox";
import { TableOverview } from "@/components/table-overview";
import { renderDefault } from "@/helpers/table-render-functions";
import { useQueryPagination } from "@/hooks/use-pagination";
import { useRouterTableData } from "@/hooks/use-router-table-data";
import { useGarListQuery } from "@/queries/query-gar";

import { FilterWrapper } from "../../components/filter-wrapper";

import { GarFilters } from "./components/gar-filters";
import { garInformation } from "./types";

export const columnDefinitions: ColumnDefinition<GAR>[] = garInformation.map(
  ({ key, label }, index) => ({
    title: label,
    renderFunction: (row) => renderDefault(row[key], index === 0 ? `/gar/${row.uuid}/` : undefined),
    width: "1fr",
  })
);

export function GarTable() {
  const {
    page,
    setPage,
    searchField: _searchField,
    searchString,
    setSearchField,
    setSearchString,
  } = useRouterTableData({ keyAddon: "GAR" });
  const searchField =
    (_searchField as keyof ApiGarGarsListRequest | undefined) || getSearchKey(garInformation[0]);
  const queryParams: ApiGarGarsListRequest = {
    page,
    ...(searchField ? { [searchField]: searchString } : {}),
  };
  const { data: garList, isLoading } = useGarListQuery(queryParams);
  const paginationProps = useQueryPagination({
    queryResponse: garList,
    page,
    setPage,
  });

  return (
    <>
      <FilterWrapper>
        <GarFilters {...{ searchField, searchString, setSearchField, setSearchString }} />
      </FilterWrapper>
      <TableOverview
        isLoading={isLoading}
        tableData={garList?.results || []}
        columnDefinitions={columnDefinitions}
        paginationProps={paginationProps}
      />
    </>
  );
}
